var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stars"},_vm._l((5),function(star,index){return _c('i',{key:index,class:_vm.getStarClass(index + 1)})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }